import { get, post, put, del } from "./api_helper"

const OtherCustomerAPI = {
  getListPage: params => get("admin/master/other-customer/page", params),
  getListHistoryPage: params =>
    get(`admin/master/other-customer/${params.id}/order-history/page`, params),
  getCSVDataApi: (id, params) =>
    get(`admin/master/other-customer/${id}/order-history/csv`, params),
  getList: () => get("admin/master/other-customer/list"),
  postData: params => post("admin/master/other-customer", params),
  getDetail: id => get(`admin/master/other-customer/${id}`),
  putData: params => put(`admin/master/other-customer/${params.id}`, params),
}

const IgarashiCustomerAPI = {
  getListPage: params => get("admin/master/igarashi-customer/page", params),
  getListHistoryPage: params =>
    get(
      `admin/master/igarashi-customer/${params.id}/order-history/page`,
      params
    ),
  getCSVDataApi: (id, params) =>
    get(`admin/master/igarashi-customer/${id}/order-history/csv`, params),
  getList: () => get("admin/master/igarashi-customer/list"),
  postData: params => post("admin/master/igarashi-customer", params),
  getDetail: id => get(`admin/master/igarashi-customer/${id}`),
  putData: params => put(`admin/master/igarashi-customer/${params.id}`, params),
  getFile: (id, params) =>
    get(`admin/master/igarashi-customer/${id}/file/page`, params),
  deleteFile: (id, idFile) =>
    del(`admin/master/igarashi-customer/${id}/file/${idFile}`),
}

export { OtherCustomerAPI, IgarashiCustomerAPI }
